import { apiClient } from '../../api/client';
import { ApiResponse } from '../../api/types';
import { IAPProduct, IAPProductInput, ShopProduct, ShopProductInput } from './types';

const SHOP_URL = '/api/v1/admin/shop/products';
const IAP_URL = '/api/v1/admin/iap/products';

export async function listShopProducts(): Promise<ShopProduct[]> {
  return (await apiClient.get<ApiResponse<ShopProduct[]>>(SHOP_URL)).data.data;
}
export async function saveShopProduct(input: ShopProductInput, id?: number): Promise<ShopProduct> {
  const response = id
    ? await apiClient.put<ApiResponse<ShopProduct>>(`${SHOP_URL}/${id}`, input)
    : await apiClient.post<ApiResponse<ShopProduct>>(SHOP_URL, input);
  return response.data.data;
}
export async function deleteShopProduct(id: number): Promise<void> {
  await apiClient.delete(`${SHOP_URL}/${id}`);
}
export async function listIAPProducts(): Promise<IAPProduct[]> {
  return (await apiClient.get<ApiResponse<IAPProduct[]>>(IAP_URL)).data.data;
}
export async function saveIAPProduct(input: IAPProductInput, editingId?: string): Promise<IAPProduct> {
  const response = editingId
    ? await apiClient.put<ApiResponse<IAPProduct>>(`${IAP_URL}/${encodeURIComponent(editingId)}`, input)
    : await apiClient.post<ApiResponse<IAPProduct>>(IAP_URL, input);
  return response.data.data;
}
export async function deleteIAPProduct(id: string): Promise<void> {
  await apiClient.delete(`${IAP_URL}/${encodeURIComponent(id)}`);
}
